// extracted by mini-css-extract-plugin
module.exports = {"size--medium":"IconLink_size--medium__cULMP","icon":"IconLink_icon___IYpx","playIcon":"IconLink_playIcon__KSerW","size--large":"IconLink_size--large__mv64N"};